<template>
    <div class="main">
        <div style="margin: 10px 16px;background-color: #fff;border-radius: 8px;padding: 1px 0;">
            <div class="div_card">
                <div>
                    <van-icon name="logistics" />
                    <a style="padding: 0 8px;">{{ form.Status }}</a>
                </div>
                <div v-if="form.DriverId" style="font-size: 14px;color: #999999;">接单时间：{{ form.DriverTime }}</div>
            </div>
            <div v-if="form.DriverId" class="div_card_diver">
                <div class="div_flex">
                    <div>送货司机：{{ form.Driver }}</div>
                    <div>
                        <a v-if="canDial(form.DriverPhone)" :href="getTelHref(form.DriverPhone)" style="color: #fff;">{{ form.DriverPhone }}</a>
                        <span v-else style="color: #fff;">{{ form.DriverPhone }}</span>
                    </div>
                </div>
                <div>收货时间：{{ form.DriverShipTime ? form.DriverShipTime : '-' }}</div>
                <div>送达时间：{{ form.DriverDeliveryTime ? form.DriverDeliveryTime : '-' }}</div>
            </div>
        </div>
        <div class="div_card" style="margin: 10px 16px;background-color: #fff;">
            <div style="display: flex;"><a class="div_icon" style="background-color: #333333;">发</a>发货人</div>
            <div style="text-align: right;">
                <div>{{ form.Name }}</div>
                <div>{{ form.Department }}</div>
                <div>
                    <a v-if="canDial(form.Phone)" :href="getTelHref(form.Phone)">手机：{{ form.Phone }}</a>
                    <span v-else>手机：{{ form.Phone || '-' }}</span>
                </div>
                <div v-if="form.Landline">
                    <a v-if="canDial(SponsorNum || form.Landline)" :href="getTelHref(SponsorNum || form.Landline)">座机：{{ form.Landline }}</a>
                    <span v-else>座机：{{ form.Landline }}</span>
                </div>
            </div>
        </div>
        <div style="border-radius: 8px;margin: 0 16px;background-color: #fff;">
            <div class="div_card">
                <div style="display: flex;"><a class="div_icon" style="background-color: #FEB013;">收</a>收货人</div>
                <div style="text-align: right;">
                    <div>{{ form.Receiver }}</div>
                    <div>{{ form.ReceiverDepartment }}</div>
                    <div>
                        <a v-if="canDial(form.ReceiverPhone)" :href="getTelHref(form.ReceiverPhone)">手机：{{ form.ReceiverPhone }}</a>
                        <span v-else>
                            手机：{{ form.ReceiverPhone || '-' }}
                            <van-tag v-if="isMaskedPhone(form.ReceiverPhone)" type="warning" size="mini" style="margin-left: 4px;">已脱敏</van-tag>
                        </span>
                    </div>
                    <div v-if="form.ReceiverLandline">
                        <a v-if="canDial(ReceiverNum || form.ReceiverLandline)" :href="getTelHref(ReceiverNum || form.ReceiverLandline)">座机：{{ form.ReceiverLandline }}</a>
                        <span v-else>座机：{{ form.ReceiverLandline }}</span>
                    </div>
                </div>
            </div>
            <div style="padding: 5px 16px;">
                <div class="div_flex" style="border-top: 1px #D2D2D2 solid;">
                    <div>发货地点</div>
                    <div>{{ form.DeliveryAddress }}</div>
                </div>
                <div class="div_flex">
                    <div>收货地点</div>
                    <div>{{ form.ShipAddress }}</div>
                </div>
                <div class="div_flex">
                    <div>送货时间</div>
                    <div>{{ form.DeliveryTime }}</div>
                </div> 
                <div class="div_flex">
                    <div>货物名称</div>
                    <div>{{ form.ItemName }}</div>
                </div>
                <div class="div_flex">
                    <div>数量</div>
                    <div>{{ form.ItemNum }}</div>
                </div>
                <div class="div_flex">
                    <div>单位</div>
                    <div>{{ form.ItemUnit }}</div>
                </div>
                <div class="div_flex">
                    <div>备注</div>
                    <div>{{ form.Remark || '-' }}</div>
                </div>
                <div class="div_flex" style="border-top: 1px #D2D2D2 solid;padding-top: 15px;">
                    <div>下单时间</div>
                    <div>{{ form.CreateTime }}</div>
                </div>
                <div class="div_flex" style="padding-bottom: 15px;">
                    <div>收货时间</div>
                    <div v-if="form.Status === '已签收'">{{ form.UpDateTime }}</div>
                </div>
            </div>
        </div>
        <div style="margin: 16px;">
            <van-button v-if="$route.query.role === 'sponsor' && ['待接单', '已接单'].includes(form.Status)" block round :disabled="btnStatus" color="#999" @click="onCancel">取消订单</van-button>
            <van-button v-if="$route.query.role === 'driver' && !form.DriverId" block round color="#333" :disabled="btnStatus" @click="onOrder">接单</van-button>
            <div v-if="$route.query.role === 'driver' && WXInfo.userid === form.DriverId && (form.Status === '已接单' || form.Status === '运送中')" class="div_flex">
                <van-button block round color="#FEB013" :disabled="form.DriverStatus !== '' || form.DriverStatus === '收货出发'" @click="onShip()">收货出发</van-button>
                <div style="width: 40px;"></div>
                <van-button block round color="#333" :disabled="form.DriverStatus === '' || form.DriverStatus === '已送达'" @click="onDelivery()">已送达</van-button>
            </div>
            <van-button v-if="$route.query.role === 'receiver' && form.Status === '运送中'" block round :disabled="btnStatus" color="#333" @click="onConfirm">确认收货</van-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            WXInfo: {},
            form: {},
            DriverList: [],
            btnStatus: false,
            SponsorNum: '',
            ReceiverNum: ''
        }
    },
    async mounted() {
        const userInfo = localStorage.getItem('userinfo')
        if (userInfo) {
            try {
                this.WXInfo = JSON.parse(userInfo).data || {}
            } catch (e) {
                this.WXInfo = {}
            }
        }
        await this.getDataById()
    },
    methods: {
        canDial(phone) {
            if (!phone) return false
            const str = String(phone).trim()
            if (str.includes('*')) return false
            return /\d/.test(str)
        },
        isMaskedPhone(phone) {
            if (!phone) return false
            return String(phone).includes('*')
        },
        getTelHref(phone) {
            if (!this.canDial(phone)) return 'javascript:void(0);'
            const cleanNum = String(phone).replace(/[^\d+-]/g, '')
            return 'tel://' + cleanNum
        },
        sendMessage(type, userid) {
            let Message = ''
            if (type === '接单通知收货人') {
                Message = '收货任务通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n发货人：' + this.form.Name +
                    '\n发货地点：' + this.form.DeliveryAddress +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n\n您收到一个收货任务，请及时处理。\n\n' +
                    '<a href="https://pinche.jafron.com/transport/detail?id='+ this.form._id +'">查看详情</a>'
            } else if (type === '接单通知发货人') {
                Message = '转货状态通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n收货人：' + this.form.Receiver +
                    '\n收货地点：' + this.form.ShipAddress +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n司机：' + this.WXInfo.name +
                    '\n\n您发起的转货任务已被司机接单。\n\n' +
                    '<a href="https://pinche.jafron.com/transport/detail?role=sponsor&id='+ this.form._id +'">查看详情</a>'
            } else if (type === '司机出发通知发货人') {
                Message = '转货状态通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n收货人：' + this.form.Receiver +
                    '\n收货地点：' + this.form.ShipAddress +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n司机：' + this.form.Driver +
                    '\n\n您需要转货的物品，司机已装运出发了，请注意查看货物情况。\n\n' +
                    '<a href="https://pinche.jafron.com/transport/detail?role=sponsor&id='+ this.form._id +'">查看详情</a>'
            } else if (type === '取消订单') {
                Message = '转货状态通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n\n该转货任务已被发起人取消。'
            } else if (type === '已送达通知收货人') {
                Message = '转货状态通知：' +
                    '\n\n送货时间：' + this.form.DeliveryTime +
                    '\n收货人：' + this.form.Receiver +
                    '\n收货地点：' + this.form.ShipAddress +
                    '\n货物：' + this.form.ItemName +
                    '\n数量：' + this.form.ItemNum +
                    '\n司机：' + this.form.Driver +
                    '\n\n您需要转货的物品，司机已送达，请前往确认。\n\n' +
                    '<a href="https://pinche.jafron.com/transport/detail?role=receiver&id='+ this.form._id +'">查看详情</a>'
            }
            this.postSendMessage(userid, Message)
        },
        async onOrder() {
            console.log('司机接单')
            const result = await this.$request({
                url: '/api/GeneralMethod/putFunctionChange',
                method: 'PUT',
                params: {
                    Name: 'transport',
                    Condition: { _id: this.$route.query.id }
                },
                data: {
                    DriverId: this.WXInfo.userid,
                    Driver: this.WXInfo.name,
                    DriverPhone: this.WXInfo.mobile,
                    DriverTime: this.$moment().format('YYYY-MM-DD HH:mm'),
                    Status: '已接单',
                    DriverStatus: ''
                }
            })
            if (result && result.success) {
                this.$toast('提交成功')
                this.sendMessage('接单通知收货人', this.form.ReceiverId)
                this.sendMessage('接单通知发货人', this.form.UserId)
                this.getDataById()
            } else {
                this.$toast((result && result.message) || '接单失败')
            }
        },
        async onShip() {
            const result = await this.$request({
                url: '/api/GeneralMethod/putFunctionChange',
                method: 'PUT',
                params: {
                    Name: 'transport',
                    Condition: { _id: this.$route.query.id }
                },
                data: {
                    DriverStatus: '收货出发',
                    Status: '运送中',
                    DriverShipTime: this.$moment().format('YYYY-MM-DD HH:mm')
                }
            })
            if (result && result.success) {
                this.$toast('提交成功')
                this.sendMessage('司机出发通知发货人', this.form.UserId)
                this.getDataById()
            } else {
                this.$toast((result && result.message) || '更新状态失败')
            }
        },
        async onDelivery() {
            const result = await this.$request({
                url: '/api/GeneralMethod/putFunctionChange',
                method: 'PUT',
                params: {
                    Name: 'transport',
                    Condition: { _id: this.$route.query.id }
                },
                data: {
                    DriverStatus: '已送达',
                    DriverDeliveryTime: this.$moment().format('YYYY-MM-DD HH:mm')
                }
            })
            if (result && result.success) {
                this.$toast('提交成功')
                this.sendMessage('已送达通知收货人', this.form.ReceiverId)
                this.getDataById()
            } else {
                this.$toast((result && result.message) || '更新状态失败')
            }
        },
        async onConfirm() {
            console.log('确认收货')
            const result = await this.$request({
                url: '/api/GeneralMethod/putFunctionChange',
                method: 'PUT',
                params: {
                    Name: 'transport',
                    Condition: { _id: this.$route.query.id }
                },
                data: {
                    Status: '已签收'
                }
            })
            if (result && result.success) {
                this.$toast('提交成功')
                this.getDataById()
            } else {
                this.$toast((result && result.message) || '确认收货失败')
            }
        },
        async onCancel() {
            console.log('取消订单')
            const result = await this.$request({
                url: '/api/GeneralMethod/deleteFunction',
                method: 'DELETE',
                params: {
                    Name: 'transport',
                    Condition: {
                        _id: this.$route.query.id,
                        UserId: this.form.UserId,
                        ReceiverId: this.form.ReceiverId,
                        Status: this.form.Status
                    }
                }
            })
            if (result && result.success) {
                if (this.form.Status === '已接单') {
                    this.sendMessage('取消订单', this.form.DriverId)
                } else {
                    // 获取车队人员列表
                    let userlist = await this.getQWUserList(3209)
                    if (Array.isArray(userlist)) {
                        userlist.forEach(item => {
                            this.sendMessage('取消订单', item.userid)
                        })
                    }
                }
                this.$router.push('/transport/index')
            } else {
                this.$toast((result && result.message) || '取消失败')
            }
        },
        async getDataById() {
            try {
                const result = await this.$request({
                    url: '/api/GeneralMethod/getFunctionById',
                    method: 'GET',
                    params: {
                        Id: this.$route.query.id,
                        Name: 'transport'
                    }
                })
                if (result && result.data) {
                    this.form = result.data
                    if (this.form.Landline && typeof this.form.Landline === 'string') {
                        const match = this.form.Landline.match(/\d+-\d+/)
                        this.SponsorNum = match ? match[0] : this.form.Landline
                    } else {
                        this.SponsorNum = ''
                    }
                    if (this.form.ReceiverLandline && typeof this.form.ReceiverLandline === 'string') {
                        const match = this.form.ReceiverLandline.match(/\d+-\d+/)
                        this.ReceiverNum = match ? match[0] : this.form.ReceiverLandline
                    } else {
                        this.ReceiverNum = ''
                    }
                }
            } catch (e) {
                console.error(e)
            }
        },
        async getQWUserList(id) {
            try {
                const result = await this.$request({
                    url: '/api/WXAuthorize/getDepartmentUserbyQW',
                    method: 'GET',
                    params: { id: id }
                })
                if (result && result.success && Array.isArray(result.data)) {
                    return result.data
                } else {
                    if (result && result.message) {
                        this.$toast(result.message)
                    }
                    return []
                }
            } catch (e) {
                return []
            }
        },
        async postSendMessage(userid, message) {
            const result = await this.$request({
                url: this.$api.postSendMessageWX,
                method: 'POST',
                data: {
                    'touser': userid,
                    'msgtype': 'text',
                    'agentid': this.$agentid,
                    'text': { 'content': message }
                }
            })
            if (!result || !result.success) {
                if (result && result.message) {
                    this.$toast(result.message)
                }
            }
        }
    }
}
</script>

<style lang="less" scoped>
.main {
    overflow: hidden;
}
.div_card {
    border-radius: 5px;
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.div_icon {
    font-size: 14px;
    font-weight: normal;
    color: #FFFFFF;
    border-radius: 50%;
    min-width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 8px;
}
.div_flex { 
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 0;
}
.div_card_diver {
    background-color: #3F97FC;
    color: #fff;
    border-radius: 12px;
    margin: 0 12px 12px 12px;
    padding: 12px;
    line-height: 1.5;
}
</style>
